<template>
  <div :class="[active?'active-sare':'']">
    <div class="row height-row" @click="active=!active">
      <div class="col-md-4 col-4 border-table">
        <span class="span-black pl-0" style="margin-left: 35px;">Sare</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black">0.06</span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black">g</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sare",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style scoped>

</style>